export const _LOAD_FEED_ = 'Load:Feed';
export const _EDIT_FILTER_ = 'Filter:Edit';
export const _LOAD_FEED_TAG_ = 'Load:FeedTagModal';
export const _CLOSED_FEED_TAG_ = 'Close:FeedTagModal';
export const _OPEN_FILTER_MODAL_ = 'Open:FeedModal';

export const FILTER_ITEMS = {
  id: null,
  value: null,
  type: null,
  feed_filter_id: null,
};

export const FILTER_MODEL = {
  id: null,
  name: null,
  users: [{ ...FILTER_ITEMS, ...{ type: 'user' } }],
  hashtags: [{ ...FILTER_ITEMS, ...{ type: 'hashtag' } }],
};

export const TAG_MODEL = {
  id: null,
  name: null,
};

export const POST_MODEL = {
  id: null,
  tags: [],
  owner: null,
  caption: null,
  selected: null,
  username: null,
  media_url: null,
  permalink: null,
  shortcode: null,
  timestamp: null,
  like_count: null,
  media_type: null,
  reference_id: null,
  comments_count: null,
  is_comment_enabled: null,
};
